import React from 'react';

export function AppStoreIcon({ className = '', ...props }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            focusable="false"
            className={className}
            {...props}
        >
            <path
                d="M15.4 2.8c.2 1.4-.4 2.7-1.1 3.6-.8 1-2 1.9-3.2 1.8-.2-1.3.4-2.7 1.1-3.5.8-1 2.1-1.8 3.2-1.9Zm3.3 16.3c-.7 1.6-1.9 3.6-3.3 3.6-1.4 0-1.8-.9-3.4-.9-1.6 0-2 .9-3.3.9-1.4 0-2.4-1.8-3.2-3.4-1.7-3.3-1.9-7.1-.8-8.9.8-1.3 2-2.1 3.3-2.1 1.2 0 2 .7 3 .7s1.8-.7 3.2-.7c1 0 2.2.6 3 1.7-2.6 1.4-2.2 5.4.5 6.9.1.1.1.2 0 .2Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function GooglePlayIcon({ className = '', ...props }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            focusable="false"
            className={className}
            {...props}
        >
            <path d="M3.6 2.8v18.4l9.1-9.2L3.6 2.8Z" fill="#34A853" />
            <path d="m13.3 12-9.7 9.8c.5.2 1.1.1 1.7-.2l11-6-3-3.6Z" fill="#4285F4" />
            <path d="M22 11.9c0-.6-.3-1.2-.9-1.5l-4.4-2.4-3.7 3.8 3.7 3.8 4.4-2.4c.6-.3.9-.9.9-1.3Z" fill="#FBBC04" />
            <path d="M16.7 7.9 5.2 1.7c-.6-.3-1.2-.4-1.6-.1l9.7 9.8 3.4-3.5Z" fill="#EA4335" />
        </svg>
    );
}
